module.exports = __webpack_public_path__ + "static/media/404Page.9c11f755.png";